import { PropsWithChildren, createContext, useState } from 'react';

enum Modals {
  Example = 'example',
  Error = 'error',
  TradeModal = 'trade-modal'
}

const defaultValue = {
  isExampleModalShown: false,
  isErrorModalShown: false,
  isTradeModalShown: false,
  setExampleModalOpen: (_: boolean) => {},
  setErrorModalOpen: (_: boolean) => {},
  setTradeInModalOpen: (_: boolean) => {}
};

const ModalContext = createContext(defaultValue);

const ModalContextProvider: React.FC<PropsWithChildren<{}>> = ({
  children
}) => {
  const [currentModal, setCurrentModal] = useState(null as null | Modals);

  const closeModal = () => {
    setCurrentModal(null);
  };

  const showModal = (modal: Modals) => {
    if (currentModal) {
      // there's already a modal showing, we shouldn't let this happen;
      console.error(`Attempted to show ${modal} while ${currentModal} is open`);
      closeModal();
    }
    setCurrentModal(modal);
  };

  const setExampleModalOpen = (isOpen: boolean) =>
    isOpen ? showModal(Modals.Example) : closeModal();

  const setErrorModalOpen = (isOpen: boolean) =>
    isOpen ? showModal(Modals.Error) : closeModal();

  const setTradeInModalOpen = (isOpen: boolean) =>
    isOpen ? showModal(Modals.TradeModal) : closeModal();

  return (
    <ModalContext.Provider
      value={{
        isErrorModalShown: currentModal === Modals.Error,
        isTradeModalShown: currentModal === Modals.TradeModal,
        isExampleModalShown: currentModal === Modals.Example,
        setExampleModalOpen,
        setErrorModalOpen,
        setTradeInModalOpen
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
export { ModalContextProvider };
